import type Category from '../types/category';
import filterTreeNodes from './filterTreeNodes';
import findInTreeNodes from './findInTreeNodes';

const getCurrentCategoryTree = (
    tree: Category[],
    activeId: string
): undefined | Category[] => {
    const lastSelectedNode = findInTreeNodes(
        tree,
        node => node.id === activeId
    );

    if (!lastSelectedNode) {
        return undefined;
    }

    const lastNodeHasChildren = lastSelectedNode.children.length;
    const categoryPath = lastSelectedNode.path.slice().map(({ id }) => id);

    let isSelectedNodeRootNode = false;

    if (lastSelectedNode.path.length === 1) {
        isSelectedNodeRootNode = true;
    }

    return filterTreeNodes(
        tree,
        node =>
            categoryPath.includes(node.id) ||
            // If the selected node has children, or if it is a root node, only consider itself.
            // Otherwise consider it's parent node.
            // Results in only children of the selected node being returned if the node has children
            // or if it is a root node. Results in the node itself as well as all of its sibling nodes
            // otherwise.
            (lastNodeHasChildren || isSelectedNodeRootNode
                ? node.parentId === activeId
                : node.parentId === lastSelectedNode.parentId)
    );
};

export default getCurrentCategoryTree;
